import { StorageKey } from "./storage";

export enum FeatureToggle {
    HotkeysEnabled = "hotkeysEnabled",
    AxisSphereVisible = "axisSphereVisible",
    MiniMapVisible = "miniMapVisible",
    JoysticksVisible = "joysticksVisible",
    UpdateHomeView = "updateHomeView",
}

export const FEATURE_TOGGLE_CONFIG: Record<FeatureToggle, { defaultValue: boolean; storageKey?: StorageKey }> = {
    [FeatureToggle.HotkeysEnabled]: { defaultValue: true },
    [FeatureToggle.AxisSphereVisible]: { defaultValue: true, storageKey: StorageKey.NavigationCube },
    [FeatureToggle.MiniMapVisible]: { defaultValue: true, storageKey: StorageKey.MiniMap },
    [FeatureToggle.JoysticksVisible]: { defaultValue: true, storageKey: StorageKey.Joysticks },
    [FeatureToggle.UpdateHomeView]: { defaultValue: false, storageKey: StorageKey.UpdateHomeView },
};
